import { useEffect, useState, useMemo, useCallback } from "react";

import { Grid, Skeleton, FormControlLabel, Checkbox, Typography } from "@mui/material";
import { useIntl } from "react-intl";

import TitledCard from "./basic/TitledCard";
import useEditedStyles from "../../hooks/useEditedStyles";
import { DeviceSettingsValue } from "../../utils/types";
import { useDevice } from "../../utils/DeviceProvider";

const DeviceSettings = () => {
  const [configurationModeIsActive, setConfigurationModeIsActive] = useState(false);

  const {
    device: { noConfig, currentValue, config },
    setCurrentValue,
    setEmptyConfig,
  } = useDevice();

  const { formatMessage } = useIntl();
  const editedStyle = useEditedStyles();

  const savedValue = useMemo<DeviceSettingsValue | null>(() => config?.toolboxConfig?.devicesettings || null, [config]);

  useEffect(() => {
    if (noConfig || (currentValue && !currentValue.devicesettings)) {
      const config = {
        configurationModeIsActive: false,
      };
      console.log("empty config: devicesettings");
      setEmptyConfig(config, "devicesettings");
      setCurrentValue((old: any) => ({ ...old, devicesettings: config }));
    }
  }, [currentValue, noConfig, setCurrentValue, setEmptyConfig]);

  useEffect(() => {
    if (currentValue?.devicesettings) {
      const { configurationModeIsActive } = currentValue.devicesettings;
      setConfigurationModeIsActive(configurationModeIsActive);
    }
  }, [currentValue]);

  const handleConfigurationModeIsActive = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (!currentValue) {
        return;
      }
      setConfigurationModeIsActive(event.target.checked);
      currentValue.devicesettings.configurationModeIsActive = event.target.checked;
      setCurrentValue(currentValue);
    },
    [currentValue, setCurrentValue]
  );

  if (!noConfig && !currentValue) {
    return (
      <TitledCard title={formatMessage({ defaultMessage: "Device settings" })} stretch={true}>
        <Grid container spacing={1} sx={{ padding: 1 }}>
          <Grid item xs={12}>
            <FormControlLabel
              control={<Skeleton variant="rectangular" height={20} width={20} sx={{ m: "4px" }} />}
              label={
                <Typography variant="caption" sx={{ paddingRight: (theme) => theme.spacing(0.5) }}>
                  {formatMessage({ defaultMessage: "Configuration mode is active" })}
                </Typography>
              }
              labelPlacement="end"
              sx={{ m: 0 }}
            />
          </Grid>
        </Grid>
      </TitledCard>
    );
  }

  return (
    <TitledCard title={formatMessage({ defaultMessage: "Device settings" })} stretch={true}>
      <Grid container spacing={1} sx={{ padding: 1 }}>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox checked={configurationModeIsActive} color="secondary" onChange={handleConfigurationModeIsActive} style={{ padding: 1, margin: 1 }} />
            }
            label={
              <Typography variant="caption" sx={{ paddingRight: (theme) => theme.spacing(0.5) }}>
                {formatMessage({ defaultMessage: "Configuration mode is active" })}
              </Typography>
            }
            labelPlacement="end"
            sx={{ m: 0, flex: 1 }}
            className={!!savedValue?.configurationModeIsActive !== !!configurationModeIsActive ? editedStyle.background : ""}
          />
          <Typography variant="caption" component="p" sx={{ color: (theme) => theme.palette.text.secondary }}>
            {/* {formatMessage({ defaultMessage: "" })} */}
            TODO: kell ide valami magyarázó szöveg?
          </Typography>
        </Grid>
      </Grid>
    </TitledCard>
  );
};

export default DeviceSettings;

export const loadConfig = (old: DeviceSettingsValue) => {
  const config = {
    configurationModeIsActive: false,
  };
  config.configurationModeIsActive = old.configurationModeIsActive;

  return config;
};
